
import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    IconButton, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon, CheckCircle as ActivateIcon, Search as SearchIcon, Info as Info } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData, postData } from '../../../apiService'; // Ensure postData is defined
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import BillPrint from './Bill';
import PrintIcon from '@mui/icons-material/Print';
import ReactDOM from 'react-dom';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import { Tooltip } from '@mui/material';
import { useLocation } from 'react-router-dom';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { toWords } from 'number-to-words';
import Logo from './../Logo/QR.png';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import logoad from './adithi_logo.png';


function SaleIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, token, logout, userId } = useAuth();

    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');

    const [isLoading, setIsLoading] = useState(false);
    const [importDialogOpen, setImportDialogOpen] = useState(false);
    const [fileData, setFileData] = useState([]);
    const [isFocused, setIsFocused] = useState(false);
    const branchId = 0;
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const location = useLocation();
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchtableData()
    }, [isAuthenticated, companyId, branchId, token, logout, fromDate, toDate]);


    useEffect(() => {
        const shouldReload = localStorage.getItem('shouldReload') === 'true';

        // Only reload data if navigated from PurchaseOrderCreate and flag is set
        if (location.state?.from === '/SaleCreate' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
        else if (location.state?.from === '/SaleEdit' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }

        else if (location.state?.from === '/SaleDetails' && shouldReload) {
            localStorage.removeItem('shouldReload'); // Clear the flag after use
            window.location.reload();
        }
        else {
            // Populate data without reloading for other cases
            //setFromDate(getFormattedStartDate());
            setFromDate(getFormattedCurrentDate());
            setToDate(getFormattedCurrentDate());
            // handleClickOpen(false);
        }
    }, [location]);

    const fetchtableData = async () => {

        setData([]);
        try {
            const response = await fetchData('SaleApi', `/SaleDetails/${companyId}/${companyId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        }
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const searchableFields = ['BillPrefix', 'FinYear', 'BillNumber', 'BillDate', 'CustomerName', 'TotalQuantity', 'TaxableAmount', 'CGSTAmount', 'SGSTAmount', 'IGSTAmount', 'GrandTotal', 'TotalQuantity'];

    const filteredData = data.filter((item) =>
        searchableFields.some((key) =>
            item[key]?.toString().toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const handleDelete = async () => {
        deleteData('SaleApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('SaleApi', `${itemId}`, token)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const handleA4Print = async (SALEID) => {
        try {
            const response = await fetchData('SaleApi', `/SalePrint/${SALEID}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();

            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };


    // const handlePrint = async (SALEID) => {
    //     try {
    //         // ------------------ FETCH DATA ------------------
    //         const response = await fetchData('SaleApi', `/SalePrint/${SALEID}`, token);
    //         const labelData = response.response_data;

    //         if (!labelData?.SalePrint || !labelData?.SalePrintItems) {
    //             throw new Error("Invalid invoice data.");
    //         }

    //         const header = labelData.SalePrint;
    //         const items = labelData.SalePrintItems;
    //         // ------------------ Dynamic height for long bills ------------------
    //         const baseHeight = 230;
    //         const itemCount = labelData.SalePrintItems?.length || 0;
    //         const dynamicHeight = Math.max(baseHeight, 120 + itemCount * 8 + 80); // estimate

    //         // ------------------ INITIALIZE PDF ------------------
    //         const doc = new jsPDF({
    //             orientation: "portrait",
    //             unit: "mm",
    //             format: [71, dynamicHeight], // auto-extend for more items
    //         });

    //         const margin = { top: 5, left: 0.8, right: 0.8 };
    //         const pageWidth = doc.internal.pageSize.getWidth();
    //         const usableWidth = pageWidth - margin.left - margin.right;
    //         let y = margin.top;

    //         const yStartOuter = margin.top - 1;

    //         // ------------------ HEADER ------------------
    //         y += 2;

    //         const logoWidth = 45;   // increase logo width
    //         const logoHeight = 30;  // increase logo height
    //         const xCenter = (pageWidth - logoWidth) / 2;  // auto center horizontally
    //         const yTop = 2;         // top margin (adjust if it touches top)
    //         doc.addImage(logoad, 'PNG', xCenter, yTop, logoWidth, logoHeight);

    //         y += 30;

    //         // ----- COMPANY ADDRESS -----
    //         doc.setFont('helvetica', 'bold');
    //         doc.setFontSize(8);
    //         const addrLines = doc.splitTextToSize(header.CompanyAddressLine || '', usableWidth);
    //         addrLines.forEach(line => {
    //             doc.text(line, pageWidth / 2, y, { align: 'center' });
    //             y += 4;
    //         });

    //         // ----- GSTIN -----
    //         if (header.CompanyGSTNumber) {
    //             doc.text(`GSTIN : ${header.CompanyGSTNumber}`, pageWidth / 2, y, { align: 'center' });
    //             y += 4;
    //         }

    //         // ----- PHONE -----
    //         if (header.CompanyContactNumber1) {
    //             doc.text(`Ph : ${header.CompanyContactNumber1}`, pageWidth / 2, y, { align: 'center' });
    //             y += 6;
    //         }

    //         // ----- BILL OF SUPPLY TITLE -----

    //         doc.setFont('helvetica', 'bold');
    //         doc.setFontSize(8);
    //         doc.text("Bill of Supply", pageWidth / 2, y, { align: 'center' });
    //         y += 3;

    //         // ------------------ BILL INFO + CUSTOMER ------------------
    //         const boxYStart = y;
    //         y += 3;

    //         doc.setFont('helvetica', 'bold');
    //         doc.setFontSize(8);

    //         const invNo = header.InvoiceNo || [header.BillNumber, header.FinYear].filter(Boolean).join('/');
    //         const billDate = header.BillDate ? new Date(header.BillDate).toLocaleDateString('en-GB') : '';
    //         const billTime = header.BillTime;

    //         doc.text(`Bill No: ${invNo}`, margin.left + 1, y);
    //         doc.text(`Date: ${billDate}`, pageWidth - margin.right - 1, y, { align: 'right' });
    //         y += 3;
    //         doc.text(`Time: ${billTime}`, pageWidth - margin.right - 1, y, { align: 'right' });
    //         y += 4;

    //         doc.setFont('helvetica', 'bold');
    //         doc.setFontSize(8);
    //         doc.text("Customer Details:", margin.left + 1, y);
    //         y += 3;

    //         doc.setFont('helvetica', 'bold');
    //         doc.setFontSize(8);
    //         doc.text(`Name: ${header.CustomerName || ''}`, margin.left + 1, y);
    //         y += 3;

    //         if (header.CustomerAddress) {
    //             doc.text(`Address: ${header.CustomerAddress}`, margin.left + 1, y);
    //             y += 3;
    //         }

    //         if (header.CustomerContactNumber) {
    //             doc.text(`Contact: ${header.CustomerContactNumber}`, margin.left + 1, y);
    //             y += 3;
    //         }

    //         const boxYEnd = y + 1;
    //         doc.setLineWidth(0.1);
    //         doc.rect(0.8, boxYStart - 1, pageWidth - 1.6, boxYEnd - boxYStart + 1);
    //         y = boxYEnd;

    //         // ------------------ ITEMS TABLE ------------------
    //         const filteredItems = items.filter(i => (i.Quantity ?? 0) > 0);
    //         const rows = filteredItems.map((i, idx) => [
    //             idx + 1,
    //             i.ItemName || "",
    //             (i.Quantity ?? 0).toString(),
    //             (i.Rate ?? 0).toFixed(2),
    //             (i.DiscountAmount ?? 0).toFixed(2),
    //             (i.TotalAmount ?? 0).toFixed(2),
    //         ]);


    //         autoTable(doc, {
    //             startY: y,
    //             margin: { left: margin.left, right: margin.right },
    //             head: [["Sr", "Product", "Qty", "Rate", "Disc", "Amount"]],
    //             body: rows,
    //             theme: "grid",
    //             styles: {
    //                 fontSize: 8,
    //                 cellPadding: 1,
    //                 lineColor: [0, 0, 0],
    //                 lineWidth: 0.1,
    //                 textColor: [0, 0, 0],
    //                 fontStyle: "bold", // ✅ bold for all item rows
    //             },
    //             headStyles: {
    //                 fillColor: [255, 255, 255],
    //                 textColor: [0, 0, 0],
    //                 lineColor: [0, 0, 0],
    //                 lineWidth: 0.1,
    //                 fontStyle: "bold", // ✅ bold for header too
    //                 halign: 'center', // ✅ centers all headers by default
    //             },
    //             columnStyles: {
    //                 0: { halign: 'left' },
    //                 1: { halign: 'left' },
    //                 2: { halign: 'right' },
    //                 3: { halign: 'right' },
    //                 4: { halign: 'right' },
    //                 5: { halign: 'right' },
    //             },
    //         });


    //         y = doc.lastAutoTable.finalY + 6;

    //         // ------------------ TOTALS (Right Side Aligned, Left Labels) ------------------
    //         const leftX = margin.left + 35;
    //         const rightX = pageWidth - margin.right - 1.5;

    //         doc.setFont('helvetica', 'bold');
    //         doc.setFontSize(8);

    //         // Taxable Amount
    //         doc.text(`Taxable Amt`, leftX, y);
    //         doc.text(`${(Number(header.TaxableAmount) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
    //         y += 4;

    //         // CGST Amount
    //         doc.text(`CGST Amt`, leftX, y);
    //         doc.text(`${(Number(header.CGSTAmount) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
    //         y += 4;

    //         // SGST Amount
    //         doc.text(`SGST Amt`, leftX, y);
    //         doc.text(`${(Number(header.SGSTAmount) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
    //         y += 4;

    //         // Round Off
    //         doc.text(`Round Off`, leftX, y);
    //         doc.text(`${(Number(header.RoundOff) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
    //         y += 4;

    //         // Total Amount (bold)
    //         doc.setFont('helvetica', 'bold');
    //         doc.setFontSize(8);
    //         doc.text(`Total Amt`, leftX, y);
    //         doc.text(`${(Number(header.GrandTotal) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
    //         y += 4;
    //         doc.setFont('helvetica', 'normal'); // reset font

    //         // ------------------ AMOUNT IN WORDS ------------------
    //         doc.setLineWidth(0.1);
    //         doc.line(margin.left, y, pageWidth - margin.right, y);
    //         y += 3;

    //         const grandTotal = Number(header.GrandTotal) || 0;
    //         const numberToWords = (num) => {
    //             const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    //             const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
    //             const inWords = (n) => {
    //                 if (n < 20) return a[n];
    //                 if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
    //                 if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' and ' + inWords(n % 100) : '');
    //                 if (n < 100000) return inWords(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + inWords(n % 1000) : '');
    //                 if (n < 10000000) return inWords(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + inWords(n % 100000) : '');
    //                 return inWords(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 ? ' ' + inWords(n % 10000000) : '');
    //             };
    //             const parts = num.toFixed(2).split('.');
    //             let words = inWords(Number(parts[0])) + ' Rupees';
    //             if (Number(parts[1]) > 0) words += ' and ' + inWords(Number(parts[1])) + ' Paise';
    //             return words + ' Only';
    //         };

    //         doc.setFont('helvetica', 'bold');
    //         doc.setFontSize(7);
    //         doc.text(`${numberToWords(grandTotal)}`, margin.left + 1, y);
    //         y += 2;

    //         // ------------------ TERMS & CONDITIONS ------------------
    //         doc.setLineWidth(0.1);
    //         doc.line(margin.left, y, pageWidth - margin.right, y);
    //         y += 3;

    //         doc.setFont('helvetica', 'bold');
    //         doc.text(" ", margin.left + 1, y);
    //         y += 5;

    //         // ------------------ FOOTER ------------------
    //         doc.setFontSize(8);
    //         doc.setFont('helvetica', 'bold');
    //         doc.text("THANK YOU. VISIT AGAIN!", pageWidth / 2, y, { align: 'center' });

    //         y += 5;

    //         doc.setFont("helvetica", "italic");
    //         doc.setFontSize(7);
    //         doc.text("Powered by Efftabs Solutions LLP", 36, y, { align: "center" });
            

    //         // ------------------ PRINT ------------------
    //         const blob = doc.output('blob');
    //         const blobUrl = URL.createObjectURL(blob);
    //         const win = window.open(blobUrl, '_blank');
    //         if (win) win.onload = () => {
    //             win.focus();
    //             win.print();
    //         };

    //     } catch (err) {
    //         console.error("Error generating invoice:", err);
    //     }
    // };

const handlePrint = async (SALEID) => {
        try {
            // ------------------ FETCH DATA ------------------
            const response = await fetchData('SaleApi', `/SalePrint/${SALEID}`, token);
            const labelData = response.response_data;

            if (!labelData?.SalePrint || !labelData?.SalePrintItems) {
                throw new Error("Invalid invoice data.");
            }

            const header = labelData.SalePrint;
            const items = labelData.SalePrintItems;
            // ------------------ Dynamic height for long bills ------------------
            const baseHeight = 230;
            const itemCount = labelData.SalePrintItems?.length || 0;
            const dynamicHeight = Math.max(baseHeight, 120 + itemCount * 8 + 80); // estimate

            // ------------------ INITIALIZE PDF ------------------
            const doc = new jsPDF({
                orientation: "portrait",
                unit: "mm",
                format: [71, dynamicHeight], // auto-extend for more items
            });

            const margin = { top: 5, left: 0.8, right: 0.8 };
            const pageWidth = doc.internal.pageSize.getWidth();
            const usableWidth = pageWidth - margin.left - margin.right;
            let y = margin.top;

            const yStartOuter = margin.top - 1;

            // ------------------ HEADER ------------------
            y += 2;

            const logoWidth = 45;   // increase logo width
            const logoHeight = 30;  // increase logo height
            const xCenter = (pageWidth - logoWidth) / 2;  // auto center horizontally
            const yTop = 2;         // top margin (adjust if it touches top)
            doc.addImage(logoad, 'PNG', xCenter, yTop, logoWidth, logoHeight);

            y += 30;

            // ----- COMPANY ADDRESS -----
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            const addrLines = doc.splitTextToSize(header.CompanyAddressLine || '', usableWidth);
            addrLines.forEach(line => {
                doc.text(line, pageWidth / 2, y, { align: 'center' });
                y += 4;
            });

            // ----- GSTIN -----
            if (header.CompanyGSTNumber) {
                doc.text(`GSTIN : ${header.CompanyGSTNumber}`, pageWidth / 2, y, { align: 'center' });
                y += 4;
            }

            // ----- PHONE -----
            if (header.CompanyContactNumber1) {
                doc.text(`Ph : ${header.CompanyContactNumber1}`, pageWidth / 2, y, { align: 'center' });
                y += 6;
            }

            // ----- BILL OF SUPPLY TITLE -----

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.text("Bill of Supply", pageWidth / 2, y, { align: 'center' });
            y += 3;

            // ------------------ BILL INFO + CUSTOMER ------------------
            const boxYStart = y;
            y += 3;

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);

            const invNo = header.InvoiceNo || [header.BillNumber, header.FinYear].filter(Boolean).join('/');
            const billDate = header.BillDate ? new Date(header.BillDate).toLocaleDateString('en-GB') : '';
            const billTime = header.BillTime;

            doc.text(`Bill No: ${invNo}`, margin.left + 1, y);
            doc.text(`Date: ${billDate}`, pageWidth - margin.right - 1, y, { align: 'right' });
            y += 3;
            doc.text(`Time: ${billTime}`, pageWidth - margin.right - 1, y, { align: 'right' });
            y += 4;

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.text("Customer Details:", margin.left + 1, y);
            y += 3;

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.text(`Name: ${header.CustomerName || ''}`, margin.left + 1, y);
            y += 3;

            if (header.CustomerAddress) {
                doc.text(`Address: ${header.CustomerAddress}`, margin.left + 1, y);
                y += 3;
            }

            if (header.CustomerContactNumber) {
                doc.text(`Contact: ${header.CustomerContactNumber}`, margin.left + 1, y);
                y += 3;
            }

            const boxYEnd = y + 1;
            doc.setLineWidth(0.1);
            doc.rect(0.8, boxYStart - 1, pageWidth - 1.6, boxYEnd - boxYStart + 1);
            y = boxYEnd;

            // ------------------ ITEMS TABLE ------------------
            const filteredItems = items.filter(i => (i.Quantity ?? 0) > 0);
            const rows = filteredItems.map((i, idx) => [
                idx + 1,
                i.ItemName || "",
                (i.Quantity ?? 0).toString(),
                (i.Rate ?? 0).toFixed(2),
                (i.DiscountAmount ?? 0).toFixed(2),
                (i.TotalAmount ?? 0).toFixed(2),
            ]);


            autoTable(doc, {
                startY: y,
                margin: { left: margin.left, right: margin.right },
                head: [["Sr", "Product", "Qty", "Rate", "Disc", "Amount"]],
                body: rows,
                theme: "grid",
                styles: {
                    fontSize: 8,
                    cellPadding: 1,
                    lineColor: [0, 0, 0],
                    lineWidth: 0.1,
                    textColor: [0, 0, 0],
                    fontStyle: "bold", // ✅ bold for all item rows
                },
                headStyles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    lineColor: [0, 0, 0],
                    lineWidth: 0.1,
                    fontStyle: "bold", // ✅ bold for header too
                    halign: 'center', // ✅ centers all headers by default
                },
                columnStyles: {
                    0: { halign: 'left' },
                    1: { halign: 'left' },
                    2: { halign: 'right' },
                    3: { halign: 'right' },
                    4: { halign: 'right' },
                    5: { halign: 'right' },
                },
            });


            y = doc.lastAutoTable.finalY + 6;

            // ------------------ TOTALS (Right Side) + DISCOUNT & PAYMENT (Left Side) ------------------
            const leftX = margin.left + 35;
            const rightX = pageWidth - margin.right - 1.5;
            const leftSideX = margin.left + 1;
            
            let yStart = y; // Save starting Y position for left side

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);

            // RIGHT SIDE - Amounts (labels right-aligned)
            const labelX = leftX + 18; // Position for right-aligned labels
            
            // Taxable Amount
            doc.text(`Taxable Amt`, labelX, y, { align: 'right' });
            doc.text(`${(Number(header.TaxableAmount) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
            y += 4;

            // CGST Amount
            doc.text(`CGST Amt`, labelX, y, { align: 'right' });
            doc.text(`${(Number(header.CGSTAmount) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
            y += 4;

            // SGST Amount
            doc.text(`SGST Amt`, labelX, y, { align: 'right' });
            doc.text(`${(Number(header.SGSTAmount) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
            y += 4;

            // Round Off
            doc.text(`Round Off`, labelX, y, { align: 'right' });
            doc.text(`${(Number(header.RoundOff) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
            y += 4;

            // LEFT SIDE - Discount & Payment Details
            let yLeft = yStart;
            
            // Discount Section
            if (header.DiscountAmount && Number(header.DiscountAmount) > 0) {
                doc.text(`Discount`, leftSideX, yLeft);
                doc.text(`: ${(Number(header.DiscountAmount) || 0).toFixed(2)}`, leftSideX + 15, yLeft);
                yLeft += 4;
            }
            
            // Payment Method Section
            const cashAmt = Number(header.CashAmount) || 0;
            const cardAmt = Number(header.CardAmount) || 0;
            const upiAmt = Number(header.UPIAmount) || 0;
            
            let hasPayment = false;
            
            if (cashAmt > 0.01) {
                doc.text(`Cash`, leftSideX, yLeft);
                doc.text(`: ${cashAmt.toFixed(2)}`, leftSideX + 15, yLeft);
                yLeft += 4;
                hasPayment = true;
            }
            if (cardAmt > 0.01) {
                doc.text(`Card`, leftSideX, yLeft);
                doc.text(`: ${cardAmt.toFixed(2)}`, leftSideX + 15, yLeft);
                yLeft += 4;
                hasPayment = true;
            }
            if (upiAmt > 0.01) {
                doc.text(`UPI`, leftSideX, yLeft);
                doc.text(`: ${upiAmt.toFixed(2)}`, leftSideX + 15, yLeft);
                yLeft += 4;
                hasPayment = true;
            }
            
            // If no payment amounts recorded, default to Cash with GrandTotal
            if (!hasPayment) {
                doc.text(`Cash`, leftSideX, yLeft);
                doc.text(`: ${(Number(header.GrandTotal) || 0).toFixed(2)}`, leftSideX + 15, yLeft);
                yLeft += 4;
            }

            // Total Amount (bold, no background)
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(10);
            doc.text(`Total Amt`, labelX, y, { align: 'right' });
            doc.text(`${(Number(header.GrandTotal) || 0).toFixed(2)}`, rightX, y, { align: 'right' });
            y += 4;
            doc.setFont('helvetica', 'normal'); // reset font

            // ------------------ AMOUNT IN WORDS ------------------
            doc.setLineWidth(0.1);
            doc.line(margin.left, y, pageWidth - margin.right, y);
            y += 3;

            const grandTotal = Number(header.GrandTotal) || 0;
            const numberToWords = (num) => {
                const a = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
                const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
                const inWords = (n) => {
                    if (n < 20) return a[n];
                    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? ' ' + a[n % 10] : '');
                    if (n < 1000) return a[Math.floor(n / 100)] + ' Hundred' + (n % 100 ? ' and ' + inWords(n % 100) : '');
                    if (n < 100000) return inWords(Math.floor(n / 1000)) + ' Thousand' + (n % 1000 ? ' ' + inWords(n % 1000) : '');
                    if (n < 10000000) return inWords(Math.floor(n / 100000)) + ' Lakh' + (n % 100000 ? ' ' + inWords(n % 100000) : '');
                    return inWords(Math.floor(n / 10000000)) + ' Crore' + (n % 10000000 ? ' ' + inWords(n % 10000000) : '');
                };
                const parts = num.toFixed(2).split('.');
                let words = inWords(Number(parts[0])) + ' Rupees';
                if (Number(parts[1]) > 0) words += ' and ' + inWords(Number(parts[1])) + ' Paise';
                return words + ' Only';
            };

            doc.setFont('helvetica', 'bold');
            doc.setFontSize(7);
            doc.text(`${numberToWords(grandTotal)}`, margin.left + 1, y);
            y += 2;

            // ------------------ TERMS & CONDITIONS ------------------
            doc.setLineWidth(0.1);
            doc.line(margin.left, y, pageWidth - margin.right, y);
            y += 3;

            doc.setFont('helvetica', 'bold');
            doc.text(" ", margin.left + 1, y);
            y += 5;

            // ------------------ FOOTER ------------------
            doc.setFontSize(8);
            doc.setFont('helvetica', 'bold');
            doc.text("THANK YOU. VISIT AGAIN!", pageWidth / 2, y, { align: 'center' });

            y += 5;

            doc.setFont("helvetica", "italic");
            doc.setFontSize(7);
            doc.text("Powered by Efftabs Solutions LLP", 36, y, { align: "center" });


            // ------------------ PRINT ------------------
            const blob = doc.output('blob');
            const blobUrl = URL.createObjectURL(blob);
            const win = window.open(blobUrl, '_blank');
            if (win) win.onload = () => {
                win.focus();
                win.print();
            };

        } catch (err) {
            console.error("Error generating invoice:", err);
        }
    };

    return (
        <div className="w-full mx-auto" style={{ width: "100%", marginTop: "-25px" }}>
            {/* Filter Bar */}
            <div
                className="flex items-center font-serif gap-3 p-2 rounded-xl shadow-sm"
                style={{ background: "#f9fafb", marginBottom: "10px" }}
            >
                <h6
                    className="uppercase tracking-wide font-serif text-black mt-2 text-gray-700 flex-grow"
                    style={{ fontSize: "14px", fontWeight: "500" }}
                >
                    Sale
                </h6>

                {/* Search */}
                <input
                    type="text"
                    placeholder="🔍 Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    style={{
                        width: isFocused ? "240px" : "180px",
                        height: "30px",
                        border: "1px solid #ddd",
                        borderRadius: "20px",
                        padding: "0 14px",
                        fontSize: "13px",
                        transition: "all 0.3s ease",
                        outline: "none",
                    }}
                />

                {/* From Date */}
                <input
                    type="date"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    style={{
                        height: "30px",
                        fontSize: "13px",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        padding: "0 6px",
                        fontFamily: 'Arial, sans-serif',
                    }}
                />

                {/* To Date */}
                <input
                    type="date"
                    value={toDate}
                    onChange={handleToDateChange}
                    style={{
                        height: "30px",
                        fontSize: "13px",
                        border: "1px solid #ddd",
                        borderRadius: "6px",
                        padding: "0 6px",
                        fontFamily: 'Arial, sans-serif',
                    }}
                />

                {/* Refresh Button */}
                <button
                    onClick={fetchtableData}
                    style={{
                        background: "#1090a3",
                        color: "white",
                        fontSize: "13px",
                        border: "none",
                        borderRadius: "20px",
                        padding: "4px 14px",
                        cursor: "pointer",
                        transition: "0.2s",
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.background = "#0b6d7a")}
                    onMouseOut={(e) => (e.currentTarget.style.background = "#1090a3")}
                >
                    Refresh
                </button>

                {hasCreateMasterPermission && (
                    <Tooltip title="Create New Sale" arrow>
                        <Button
                            component={Link}
                            to="/SaleCreate"
                            style={{
                                background: "#3F4F44",
                                color: "white",
                                fontSize: "12px",
                                border: "none",
                                borderRadius: "20px",
                                padding: "4px 14px",
                                cursor: "pointer",
                                transition: "0.2s",
                                fontFamily: 'inherit'
                            }}
                        >
                            Create
                        </Button>
                    </Tooltip>
                )}
            </div>

            {/* Table */}
            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', marginTop: '-10px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        {/* ERP-style Header */}
                        {/* <TableHead>
                            <TableRow style={{
                                backgroundColor: "#0f172a",
                                boxShadow: "inset 0 -3px 6px rgba(0,0,0,0.3)"
                            }}>
                                {["Sl.No", "BILL DATE", "BILL NO", "NAME", "AMOUNT", "CGST", "SGST", "IGST", "TOTAL", "QTY", ""].map(head => (
                                    <TableCell key={head} style={{
                                        fontSize: "11px",
                                        fontWeight: "700",
                                        textTransform: "uppercase",
                                        borderBottom: "2px solid #1e293b",
                                        color: "#ffffff",
                                        //padding: "4px 8px",
                                        padding: "1px",
                                        textAlign: ["AMOUNT", "CGST", "SGST", "IGST", "TOTAL", "QTY"].includes(head) ? "right" : "left",
                                        textShadow: "1px 1px 2px rgba(0,0,0,0.3)"
                                    }}>{head}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead> */}
                        <TableHead>
                            <TableRow
                                style={{
                                    backgroundColor: "#0f172a",
                                    boxShadow: "inset 0 -3px 6px rgba(0,0,0,0.3)"
                                }}
                            >
                                {["Sl.No", "BILL DATE", "BILL NO", "NAME", "AMOUNT", "CGST", "SGST", "IGST", "TOTAL", "QTY", ""].map(
                                    (head) => (
                                        <TableCell
                                            key={head}
                                            style={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2, // ensures header stays above content
                                                backgroundColor: "#0f172a", // reapply background since sticky loses it
                                                fontSize: "12px",
                                                fontWeight: "700",
                                                textTransform: "uppercase",
                                                borderBottom: "2px solid #1e293b",
                                                color: "#ffffff",
                                                padding: "4px 8px",
                                                textAlign: ["AMOUNT", "CGST", "SGST", "IGST", "TOTAL", "QTY"].includes(head)
                                                    ? "right"
                                                    : "left",
                                                textShadow: "1px 1px 2px rgba(0,0,0,0.3)"
                                            }}
                                        >
                                            {head}
                                        </TableCell>
                                    )
                                )}
                            </TableRow>
                        </TableHead>

                        {/* Table Body */}
                        <TableBody sx={{ backgroundColor: 'white' }}>
                            {filteredData.map((item, index) => (
                                <TableRow key={item.id} className={item.IsActive ? '' : 'inactiveRow'} sx={{
                                    '&:hover': { backgroundColor: '#E3FEF7' },
                                    fontSize: '11.5px',
                                    padding: '3px',
                                    cursor: 'pointer'
                                }}>
                                    <TableCell style={{ fontSize: '13.5px', padding: '3px' }}>{index + 1}</TableCell>
                                    <TableCell style={{ fontSize: '13.5px', padding: '3px' }}>{formatDate(item.BillDate)}</TableCell>
                                    <TableCell style={{ fontSize: '13.5px', padding: '3px' }}>{item.BillNumber}/{item.FinYear}</TableCell>
                                    <TableCell style={{ fontSize: '13.5px', padding: '3px' }}>{item.CustomerName}</TableCell>
                                    <TableCell style={{ fontSize: '13.5px', padding: '3px', textAlign: 'right' }}>{item.TaxableAmount}</TableCell>
                                    <TableCell style={{ fontSize: '13.5px', padding: '3px', textAlign: 'right' }}>{item.CGSTAmount}</TableCell>
                                    <TableCell style={{ fontSize: '13.5px', padding: '3px', textAlign: 'right' }}>{item.SGSTAmount}</TableCell>
                                    <TableCell style={{ fontSize: '13.5px', padding: '3px', textAlign: 'right' }}>{item.IGSTAmount}</TableCell>
                                    <TableCell style={{ fontSize: '13.5px', padding: '3px', textAlign: 'right' }}>{item.GrandTotal}</TableCell>
                                    <TableCell style={{ fontSize: '13.5px', padding: '3px', textAlign: 'right' }}>{item.TotalQuantity}</TableCell>
                                    <TableCell style={{ fontSize: '11.5px', padding: '3px', textAlign: 'right' }}>
                                        {/* Actions */}
                                        {hasCreateMasterPermission && (
                                            <Tooltip title="Sale Return" arrow>
                                                <IconButton component={Link} to={`/SaleReturnCreate/${item.Id}`} color="primary">
                                                    <AssignmentReturnIcon style={{ fontSize: '17px' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        <Tooltip title="Sale Details" arrow>
                                            <IconButton component={Link} to={`/SaleDetails/${item.Id}`} color="warning">
                                                <Info style={{ fontSize: '17px' }} />
                                            </IconButton>
                                        </Tooltip>
                                        {hasCreateMasterPermission && item.IsActive && (
                                            <Tooltip title="Sale Print" arrow>

                                                <IconButton onClick={() => handlePrint(item.Id)}>
                                                    <PrintIcon style={{ fontSize: '19px', color: 'darkmagenta' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {/* {hasCreateMasterPermission && item.IsActive && (
                                            <Tooltip title="Sale A4 Print" arrow>
                                                <IconButton onClick={() => handleA4Print(item.Id)}>
                                                    <PictureAsPdfIcon style={{ fontSize: '15px', color: 'darkmagenta' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )} */}
                                        {hasEditMasterPermission && item.IsActive && (
                                            <Tooltip title="Sale Edit" arrow>
                                                <IconButton component={Link} to={`/SaleEdit/${item.Id}`} color="primary">
                                                    <EditIcon style={{ fontSize: '17px' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {hasDeleteMasterPermission && item.IsActive && (
                                            <Tooltip title="Sale Delete" arrow>
                                                <IconButton onClick={() => openConfirmDialog(item.Id)} color="error">
                                                    <DeleteIcon style={{ fontSize: '17px' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {!item.IsActive && (
                                            <Tooltip title="Sale Activate" arrow>
                                                <IconButton onClick={() => handleActivate(item.Id)} color="success">
                                                    <ActivateIcon style={{ fontSize: '17px' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>


            </div>

            {/* Confirmation Dialog with ERP-style Header */}
            <Dialog
                open={confirmDialogOpen}
                onClose={closeConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ style: { borderRadius: '8px', overflow: 'hidden', minWidth: '350px' } }}
            >
                <DialogTitle
                    id="alert-dialog-title"
                    style={{
                        background: "linear-gradient(120deg, #0f172a, #1e40af)",
                        color: "#fff",
                        fontWeight: "700",
                        fontSize: "14px",
                        padding: "12px 16px",
                        textShadow: "1px 1px 2px rgba(0,0,0,0.3)",
                        borderBottom: "2px solid #0e3b91",
                    }}
                >
                    Delete Record?
                </DialogTitle>
                <DialogContent style={{ padding: "16px", fontSize: "13px", color: "#374151" }}>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ padding: "12px 16px", gap: "8px" }}>
                    <button
                        onClick={closeConfirmDialog}
                        style={{
                            backgroundColor: '#dc3545',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '6px 14px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '600',
                            transition: '0.2s',
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#b02a37')}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#dc3545')}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleDelete}
                        style={{
                            backgroundColor: '#28a745',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '6px 14px',
                            cursor: 'pointer',
                            fontSize: '12px',
                            fontWeight: '600',
                            transition: '0.2s',
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#218838')}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#28a745')}
                    >
                        Confirm
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default SaleIndex;



